import { Controller } from "@hotwired/stimulus"

export default class CoreuiCollapseControlController extends Controller {
  static outlets = ["coreui-collapse"]

  toggle(event) {
    this.coreuiCollapseOutlets.forEach((owner) => owner.toggle(event))
  }

  show(event) {
    this.coreuiCollapseOutlets.forEach((owner) => owner.show(event))
  }

  hide() {
    this.coreuiCollapseOutlets.forEach((owner) => owner.hide())
  }
}
